import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_proto_baby_accessories: FaireCategoryEntity = {
  token: "cat_proto_baby-accessories",
  type: "category",
  name: "Baby accessories",
  level: 1,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
